import { randomBytes } from 'crypto';
import crypto from 'crypto';
import { axiosApiInstance } from './axiosApiInstanse';
import { jwtDecode } from 'jwt-decode';
import { setLanguage } from '../../../translate/Translate';

export async function login() {
  var verifier = base64URLEncode(randomBytes(32));
  var challenge = base64URLEncode(sha256(verifier));
  const url = process.env.REACT_APP_CONNECT_AUTHORIZE_URL! + challenge + '&code_challenge_method=S256';
  window.open(url, '_self');
  localStorage.setItem('codeVerifier', verifier);
}

export async function logout() {
  var verifier = base64URLEncode(randomBytes(32));
  var challenge = base64URLEncode(sha256(verifier));
  const url = process.env.REACT_APP_CONNECT_LOGOUT! + challenge;
  window.open(url, '_self');
  localStorage.removeItem('token');
}

function base64URLEncode(str: any) {
  return str.toString('base64').replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

function sha256(buffer: any) {
  return crypto.createHash('sha256').update(buffer).digest();
}

export async function generateToken() {
  var newUrl = new URL(window.location.href);

  if (
    newUrl.searchParams.has('code') &&
    (localStorage.getItem('token') === null || localStorage.getItem('token') === 'undefined')
  ) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const code = urlParams.get('code');
    var tokenUrl = process.env.REACT_APP_CONNECT_TOKEN_URL!;
    var tokenContent =
      'grant_type=authorization_code' +
      '&client_id=diagnostics.tool' +
      '&code=' +
      code +
      '&redirect_uri=' +
      process.env.REACT_APP_BASE_URL! +
      '&code_verifier=' +
      localStorage.getItem('codeVerifier');

    const tokenResponse = await fetch(tokenUrl, {
      method: 'POST',
      body: tokenContent,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
    var bodyTokenResponse = await tokenResponse.json();
    var token: any = bodyTokenResponse.access_token;
    var refreshToken: any = bodyTokenResponse.refresh_token;
    localStorage.setItem('token', token);
    localStorage.setItem('refreshToken', refreshToken);
    window.open(process.env.REACT_APP_BASE_URL!, '_self');
  }
  const tokenFromLocalStorage: string | null = localStorage.getItem('token');
  if (tokenFromLocalStorage !== null && tokenFromLocalStorage !== 'undefined') {
    await getAccountInformation(tokenFromLocalStorage);
  }
}

function getClaimsFromToken(token: string): { aid?: string; uid?: string } {
  try {
    const decoded = jwtDecode<{ [key: string]: any }>(token);
    console.log('decoded', decoded);
    return {
      aid: decoded.aid,
      uid: decoded.uid,
    };
  } catch (error) {
    console.log('Error decoding token:', error);
    return {};
  }
}

async function getAccountInformation(token: string) {
  const claims = getClaimsFromToken(token);
  console.log('process.env.REACT_APP_GET_ACCOUNT_INFO', process.env.REACT_APP_GET_ACCOUNT_INFO);
  if (claims.aid && claims.uid) {
    const getAccountInformationUrl = `${process.env.REACT_APP_GET_ACCOUNT_INFO}`
      // eslint-disable-next-line
      .replace('${accountId}', claims.aid)
      // eslint-disable-next-line
      .replace('${userId}', claims.uid);

    try {
      const accountInformation = await axiosApiInstance.get(getAccountInformationUrl);
      const bodyAccountInformation: any = await accountInformation.data.data;
      const name = bodyAccountInformation.firstName;
      var firstLetter: string = name.charAt(0);
      localStorage.setItem('firstLetter', firstLetter);
      localStorage.setItem('userId', claims.uid);
      setLanguage(bodyAccountInformation.uiLanguageCode);
    } catch (error) {
      console.error('Error fetching account information:', error);
    }
  }
}

export async function refreshJWTToken(refreshToken: any) {
  var tokenUrl = process.env.REACT_APP_CONNECT_TOKEN_URL!;
  var tokenContent = 'grant_type=refresh_token&client_id=diagnostics.tool&refresh_token=' + refreshToken;

  const tokenResponse = await fetch(tokenUrl, {
    method: 'POST',
    body: tokenContent,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });
  var bodyTokenResponse = await tokenResponse.json();
  var refreshedToken: any = bodyTokenResponse.access_token;
  localStorage.setItem('token', refreshedToken);
}
